// @flow

import * as React from 'react'
import style from './Header.css'

type headerType = {
  title: string
}

const Header = ({ title }: headerType): React.Node => {
  if (!title) return <header className={style.header} />
  return (
    <header className={style.header}>
      <h2>{title}</h2>
    </header>
  )
}

Header.defaultProps = {
  title: ''
}

export default Header



// WEBPACK FOOTER //
// ./src/shared/components/Header/Header.js